import { createSvgComponent } from "../../icon/createSvgComponent";
import Textfieldclose from "@core/__generated__/icon/figma/textfieldclose.svg";
export default createSvgComponent(Textfieldclose);